import type { ModuleTypes } from "@repo/database";
import { createContext, useContext } from "react";

import type { User, UserSubscription } from "~/providers/user-provider";

export interface UserContext {
  user: User;
  isAdmin: boolean;
  subscriptions: UserSubscription[];
  modules: ModuleTypes[];
  trialEnded: boolean;
}

export const UserContext = createContext<UserContext | undefined>(undefined);

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }

  return context;
};
